/**
 * Video Modal Player
 * Handles YouTube and MP4 video playback in modal overlay
 */

jQuery(document).ready(function ($) {

    // Create modal HTML (similar to footer document modal)
    function createVideoModal() {
        if ($('#video-modal').length) return;

        const modalHTML = `
      <div id="video-modal" class="video-modal" style="display: none;">
        <div class="video-modal-overlay"></div>
        <div class="video-modal-content">
          <button class="video-modal-close" aria-label="Close video">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div class="video-modal-player"></div>
        </div>
      </div>
    `;

        $('body').append(modalHTML);
    }

    // Open modal with video
    function openVideoModal(videoType, videoData) {
        createVideoModal();

        const $modal = $('#video-modal');
        const $player = $('.video-modal-player');

        // Clear previous content
        $player.empty();

        if (videoType === 'youtube') {
            // YouTube iframe embed
            const iframe = `
        <iframe 
          width="100%" 
          height="100%" 
          src="https://www.youtube.com/embed/${videoData}?autoplay=1&rel=0" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen>
        </iframe>
      `;
            $player.html(iframe);
        } else if (videoType === 'mp4') {
            // MP4 video element
            const video = `
        <video controls autoplay style="width: 100%; height: 100%;">
          <source src="${videoData}" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      `;
            $player.html(video);
        }

        // Show modal
        $modal.fadeIn(300);
        $('body').addClass('video-modal-open');
    }

    // Close modal
    function closeVideoModal() {
        const $modal = $('#video-modal');
        const $player = $('.video-modal-player');

        $modal.fadeOut(300, function () {
            $player.empty(); // Stop video playback
        });
        $('body').removeClass('video-modal-open');
    }

    // Click handler for video previews
    $(document).on('click', '.video-preview', function () {
        const videoType = $(this).data('video-type');
        const videoData = videoType === 'youtube'
            ? $(this).data('video-id')
            : $(this).data('video-url');

        if (videoData) {
            openVideoModal(videoType, videoData);
        }
    });

    // Close modal handlers
    $(document).on('click', '.video-modal-close, .video-modal-overlay', function () {
        closeVideoModal();
    });

    // ESC key to close
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $('#video-modal').is(':visible')) {
            closeVideoModal();
        }
    });

});
